export const SvgSemDados = () => {
  return (
    <div className='flex w-full flex-col items-center justify-center gap-4 py-10'>
      <p className='font-rubik text-lg'>Nada por aqui...</p>
    </div>
  )
}
